import { tiles } from "@/constants";
import { Link } from "react-router-dom";

const ServicesTabs = () => {
  return (
    <section className="mt-5">
      <h1 className="text-lg font-semibold">Quick Actions</h1>

      <div className="font-geist mt-2 grid w-full grid-cols-3 gap-2 rounded-xl bg-gray-100/70 py-4 dark:border-darkBorder/30 border font-medium lg:gap-5 dark:bg-[#111417] border-gray-100">
        {tiles.map((tile, index) => (
          <div
            key={index}
            className="group mx-auto flex size-[85px] cursor-pointer items-center justify-center gap-2 rounded-2xl"
          >
            <Link
              to={tile.route}
              onClick={() => scrollTo(0, 0)}
              className="flex aspect-square h-[90px] w-[90px] flex-col items-center justify-center gap-2 rounded-lg"
            >
              <div className="dark:bg-darkBg rounded-xl bg-blue-100 p-3">
                <tile.icon
                  size={23}
                  className="dark:group-hover:text-primary text-blue-500 transition-colors duration-300 dark:text-white"
                />
              </div>

              <h1 className="group-hover: text-center text-[13px] font-medium transition-all duration-300 group-hover:font-semibold">
                {tile.name}
              </h1>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesTabs;
